import { render, staticRenderFns } from "./EmployeeList.vue?vue&type=template&id=136d7ab2"
import script from "./EmployeeList.vue?vue&type=script&lang=js"
export * from "./EmployeeList.vue?vue&type=script&lang=js"
import style1 from "./EmployeeList.vue?vue&type=style&index=1&id=136d7ab2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports